export default {
    title: "",
    subtitle: "Boleto",
    path: "transaction_boleto",
    paragraphs: 
      [
        "Boleto is a Brazilian payment method that generates a document containing a unique number and a barcode. It can be paid at banks, authorized retail stores, ATMs, or directly through the customer's banking app. You define the expiration date when generating the boleto. Once your customer makes the payment, confirmation can take up to 3 business days, as the settlement process is not instant. Paid or not, you will receive a webhook with the status change.",
        "Please note that, due to regulatory requirements, the boleto must display the payer’s full address. Therefore, the subject_id provided must be registered with all address_* fields. Additionally, both email and phone number are also mandatory.",
        "After generating the boleto, three new variables will appear in the response:",
        "1. \"url_pdf\": an endpoint to download a full PDF²;",
        "2. \"bar_code\": A string that can be converted to an image, so it can be displayed to your customer - to be scanned later;",
        "3. \"digital_line\": A string that can be displayed with the option to enable the customer to copy the boleto bar code and paste it into their bank app."
      ],
    request:  {
      method: "POST", 
      endpoint: "/transactions",
      payload: {
        "transaction": {
          "currency": "BRL",
          "exchange_currency": "USD",
          "value": "400.00",
          "from_boleto": {
            "expire_at": "2023-08-30"
          },
          "to_bank_account_id": "your internal cash-in USD/BRL id",
          "subject_id": "customer id"
        }
      },
      responses: {
        "data": {
          "value": "400.00",
          "to_bank_account": {
            "routing_number": "011103093",
            "pix_info": null,
            "owner_name": "Power Co. Ltd.",
            "owner_document_number": null,
            "owner_company": {
              "social_name": "POWER HOME THEATER",
              "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
              "document_type": "tax_id",
              "document_number": "2348909854385"
            },
            "nickname": null,
            "internal": false,
            "intermediary_bank_account": null,
            "id": "b51dff12-071f-486d-9667-9f3295186e3b",
            "iban": "DE89 3704 0044 0532 0130",
            "currency": "USD",
            "branch_number": null,
            "branch_country": null,
            "bank": {
              "swift": "BOFAUS2N",
              "name": "Bank of America",
              "id": "74673d00-b36c-40ed-b34c-19c6602e09f0",
              "code": null,
              "ispb": null,
              "country": null
            },
            "account_type": "conta-corrente",
            "account_number": "000518987",
            "aba": null
          },
          "subject_is_receiver": false,
          "subject_id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
          "subject": {
            "updated_at": "2023-08-10T14:33:08.174767",
            "status": "approved",
            "social_name": "Amedeo Mancini",
            "rfc_pf": null,
            "required_clearance_level": 2,
            "references": [],
            "phone_number": "434898404898",
            "net_monthly_average_income": "5000.00",
            "inserted_at": "2021-03-26T20:22:04.358980",
            "id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
            "fiscal_country": "Brasil",
            "email": "accept@test.com",
            "document_type": "cpf",
            "document_number": "20000000027",
            "clearance_level": 2,
            "birth_date": null,
            "address_street": "Alameda Cannobio",
            "address_state": "MG",
            "address_postal_code": "34008009",
            "address_number": "75",
            "address_neighborhood": "Jardim dos Alpes",
            "address_country": "Brasil",
            "address_complement": "Apto 1005",
            "address_city": "Nova Lima"
          },
          "status": "pending",
          "source_name": "Amedeo Mancini",
          "source_document_type": "cpf",
          "source_document_number": "20000000027",
          "meta": null,
          "inserted_at": "2023-08-10T14:33:08.161412",
          "id": "6fd2af11-dbb8-4d89-b761-8d7c6ac458e5",
          "from_credit_card": null,
          "for_exchange": true,
          "exchange_under_request": false,
          "exchange_currency": "USD",
          "estimated_value_until_exchange": false,
          "currency": "BRL",
          "cleared": true,
          "from_boleto": {
            "bar_code": "19826349578720611155268124261060776497871242",
            "city": "Birigui",
            "district": "Res. Sao Jose",
            "expire_at": "2024-08-30",
            "inserted_at": "2024-08-11T16:13:17.729215",
            "line": "58973.44844 89239.499662 57704.966099 0 41481286139131",
            "name": "Joaquim dos Santos",
            "state_code": "SP",
            "status": "created",
            "street_line_1": "Rua Barão do Rio Branco, 310",
            "street_line_2": "Apt 20",
            "tax_id": "676.457.273-90",
            "updated_at": "2024-08-12T10:13:12.521215",
            "url_pdf": "https://api.facilitapay.com/api/v1/transactions/6fd2af11-dbb8-4d89-b761-8d7c6ac458e5/boleto_pdf",
            "zip_code": "16201-220"
          },
          "bank_transaction": null
        }
      }
    },
    parameterPayload: [
    {
      name: "transaction",
      type: "object",
      required: true,
      description: "An object containing all the required values needed"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "Source currency for the transaction (ISO 4217 format)"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "Currency to be exchanged (ISO 4217 format)"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: "Value to be exchanged (in the source currency)"
    },
    {
      name: "transaction.from_boleto",
      type: "object",
      required: true,
      description: "An object, containing the following parameters:"
    },
    {
      name: "transaction.from_boleto.expire_at",
      type: "string",
      required: true,
      description: "Expiration date of the boleto in YYYY-MM-DD format"
    },
    {
      name: "transaction.to_bank_account_id",
      type: "string",
      required: true,
      description: "ID of the account you will send the funds after the boleto is paid"
    },
    {
      name: "transaction.subject_id",
      type: "string",
      required: true,
      description: "ID of your customer¹"
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionBoleto.js